import React from 'react';
import styled from 'styled-components';
import THEME from '../theme';
import { AlertTriangle, Info } from './Icons';
const Alert = (props) => {
    return (React.createElement(StyledAlert, Object.assign({}, props, { size: props.size }),
        React.createElement(AlertTriangle, { style: { margin: '0em 0.5em 0em 0em' } }),
        ' ',
        React.createElement("div", null,
            React.createElement("h2", { style: props.description ? {} : { marginBottom: 0 } }, props.message),
            props.description && React.createElement("p", null, props.description)),
        props.faq && (React.createElement("a", { href: props.faq, target: "_blank", style: { color: 'inherit', marginLeft: 5 }, onClick: (e) => {
                e.stopPropagation();
            }, rel: "noreferrer" },
            React.createElement(Info, null)))));
};
export default Alert;
const StyledAlert = styled.div `
  padding: ${(props) => (props.size === 'small' ? 10 : THEME.GRID_SPACING)}px;
  ${(props) => (props.size === 'small' ? 'font-size: .7em;' : '')}
  background-color: ${THEME.WARNING};
  margin-bottom: ${(props) => props.size === 'small' ? 10 : THEME.GRID_SPACING}px;
  color: ${THEME.COLOR_SECONDARY};
  border-radius: 3px;
  display: flex;
  align-items: center;

  h2 {
    margin: 0em !important;
    font-size: 1em;
  }

  p {
    margin: 0em 0em 0em 0em;
    font-size: 0.8em;
  }

  a {
    display: flex;
    font-size: 1.3em;
  }
`;
//# sourceMappingURL=Alert.js.map